const PREFIX = 'RESOURCE'

export const CATEGORIES_GET_STATUS = `${PREFIX}_CATEGORIES_GET_STATUS`
export const CATEGORIES_GET = `${PREFIX}_CATEGORIES_GET`
export const CATEGORIES_GET_ERROR = `${PREFIX}_CATEGORIES_GET_ERROR`

export const CATEGORIES_GET_BY_ID = `${PREFIX}_CATEGORIES_GET_BY_ID`
export const CATEGORIES_CLEAR = `${PREFIX}_CATEGORIES_CLEAR`

export const CATEGORY_GET_STATUS = `${PREFIX}_CATEGORY_GET_STATUS`
export const BREAD_CRUMBS_SET_STATUS = `${PREFIX}_BREAD_CRUMBS_SET_STATUS`
export const BREAD_CRUMBS_SET = `${PREFIX}_BREAD_CRUMBS_SET`
export const CATEGORY_GET = `${PREFIX}_CATEGORY_GET`
export const CATEGORY_GET_ERROR = `${PREFIX}_CATEGORY_GET_ERROR`

export const CATEGORY_RESOURCES_GET_STATUS = `${PREFIX}_CATEGORY_RESOURCES_GET_STATUS`
export const CATEGORY_RESOURCES_GET = `${PREFIX}_CATEGORY_RESOURCES_GET`
export const CATEGORY_RESOURCES_GET_ERROR = `${PREFIX}_CATEGORY_RESOURCES_GET_ERROR`

export const RESOURCE_GET = `${PREFIX}_GET`
export const RESOURCE_CLEAR = `${PREFIX}_CLEAR`
export const RESOURCE_GET_ERROR = `${PREFIX}_GET_ERROR`

export const RESOURCE_TOGGLE_VIEW = `${PREFIX}_TOGGLE_VIEW`
export const RESOURCE_GET_TAGS_LIST = `${PREFIX}_GET_TAGS_LIST`
export const RESOURCE_GET_TAGS_LIST_ERROR = `${PREFIX}_GET_TAGS_LIST_ERROR`
export const RESOURCE_TOGGLE_DEFAULT_VIEW = `${PREFIX}_TOGGLE_DEFAULT_VIEW`

export const RESOURCE_GET_TYPES_LIST = `${PREFIX}_GET_TYPES_LIST`
export const RESOURCE_GET_TYPES_LIST_ERROR = `${PREFIX}_GET_TYPES_LIST_ERROR`

export const RESOURCE_GET_AUTHORS_LIST = `${PREFIX}_GET_AUTHORS_LIST`
export const RESOURCE_GET_AUTHORS_LIST_ERROR = `${PREFIX}_GET_AUTHORS_LIST_ERROR`
